import '@fortawesome/fontawesome-free/css/all.css'
import { bootBugsnag } from './boot/bootBugsnag'

import Vue from 'vue'
import i18n from './plugins/i18n'
import App from './App.vue'
import router from './router'

bootBugsnag(Vue)

import './plugins/vuetify'
import './plugins/base' // Initializes all the base componets
import './plugins/axios'
// Vue Mansonry
import VueMasonry from 'vue-masonry-css'
// auth plugin
import authPlugin from './plugins/auth'
// app plugin
import appPlugin from './plugins/app'
// cart plugin
import cartPlugin from './plugins/cart'
//import jquery from 'jquery'
//(window as any).$ = jquery



Vue.use(VueMasonry)

Vue.use(authPlugin)

Vue.use(appPlugin)

Vue.use(cartPlugin)

Vue.filter('currency', (val: number) => {
  if (!val) return null
  return (val * 100 / 100).toFixed(2) + '€'
})

Vue.config.productionTip = true


new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
